export const NO_DATA_TITLE_GENERIC = "Hmm";
export const NO_DATA_BODY_GENERIC = "Something's a miss, no data found";
